import { ChevronDown, ChevronUp, Plus, PlusCircle } from "lucide-react";
import { ReactNode, useState } from "react";

interface SectionCollapsibleProps {
	children?: ReactNode;
	Icon: React.ComponentType<{ size?: number, className?: string }>
	title: string;
	count?: number;
	isEditing: boolean;
	isExpanded?: boolean;
	onAdd?: () => void;
}

export const SectionCollapsible: React.FC<SectionCollapsibleProps> = ({ children, Icon, title, count, isEditing, isExpanded = false, onAdd }) => {
	const [show, setShow] = useState(isExpanded)
	return <div className="w-full flex items-center justify-between rounded-lg transition-all mb-8">
		<div className="w-full flex flex-col gap-2">
			<div className="w-full flex items-center justify-around gap-2 cursor-pointer shadow-2xs p-1 rounded-md" onClick={() => setShow(!show)}>
				<div className="w-full flex items-center gap-1 justify-start">
					<Icon className="w-5 h-5 text-indigo-600" />
					<span className="text-md font-semibold text-gray-800">{title}</span>
					{count !== undefined && (
						<span className="text-xs bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full">{count}</span>
					)}
				</div>
				<div className="flex items-center gap-4">
					{isEditing && onAdd && <PlusCircle onClick={(event) => { event.stopPropagation(); onAdd(); }} className="w-5 h-5 cursor-pointer" />}
					{show ? <ChevronUp className="w-5 h-5"/> : <ChevronDown className="w-5 h-5" onClick={() => setShow(!show)}/>}
				</div>
			</div>
			{show && children}
		</div>
	</div>
};
